export default __webpack_public_path__ + "static/modified-writer-b798531f2f35ae2713539db6f92e8959.svg";